// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InvitePartnerPage_pageHeader__mTrl3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.InvitePartnerPage_pageHeader__mTrl3 h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.InvitePartnerPage_pageHeader__mTrl3 .InvitePartnerPage_right__t9X6N {
  display: flex;
  align-items: center;
  gap: 20px;
}
.InvitePartnerPage_pageHeader__mTrl3 .InvitePartnerPage_right__t9X6N .InvitePartnerPage_date__0gS0- {
  display: flex;
  align-items: center;
  gap: 4px;
}
.InvitePartnerPage_pageHeader__mTrl3 .InvitePartnerPage_right__t9X6N .InvitePartnerPage_date__0gS0- img,
.InvitePartnerPage_pageHeader__mTrl3 .InvitePartnerPage_right__t9X6N .InvitePartnerPage_date__0gS0- svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.InvitePartnerPage_pageHeader__mTrl3 .InvitePartnerPage_right__t9X6N .InvitePartnerPage_date__0gS0- span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.InvitePartnerPage_pageMain__Z6Y6s {
  padding: 0 24px;
}

.InvitePartnerPage_card__0JncS {
  width: 100%;
  height: 100%;
  background: var(--bg1);
  border-radius: var(--border-radius-large);
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.1019607843);
  padding: 58px 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
@media (max-width: 768px) {
  .InvitePartnerPage_card__0JncS {
    flex-direction: column;
  }
}

.InvitePartnerPage_inviteImg__u6n9a {
  margin-left: -20px;
  width: 215px;
  height: 143px;
}`, "",{"version":3,"sources":["webpack://./src/pages/invitePartner/InvitePartnerPage.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AACD;AACC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAAH;AAEG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAGG;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AADJ;;AAOA;EACC,eAAA;AAJD;;AAOA;EACC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yCAAA;EACA,wDAAA;EACA,kBAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AALD;AAOC;EAbD;IAcE,sBAAA;EAJA;AACF;;AAOA;EACC,kBAAA;EACA,YAAA;EACA,aAAA;AAJD","sourcesContent":[".pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tmargin-bottom: 16px;\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t}\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 20px;\r\n\r\n\t\t.date {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.pageMain {\r\n\tpadding: 0 24px;\r\n}\r\n\r\n.card {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: var(--bg1);\r\n\tborder-radius: var(--border-radius-large);\r\n\tbox-shadow: 0px 4px 20px 0px #0000001a;\r\n\tpadding: 58px 50px;\r\n\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tgap: 10px;\r\n\r\n\t@media (max-width: 768px) {\r\n\t\tflex-direction: column;\r\n\t}\r\n}\r\n\r\n.inviteImg {\r\n\tmargin-left: -20px;\r\n\twidth: 215px;\r\n\theight: 143px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `InvitePartnerPage_pageHeader__mTrl3`,
	"right": `InvitePartnerPage_right__t9X6N`,
	"date": `InvitePartnerPage_date__0gS0-`,
	"pageMain": `InvitePartnerPage_pageMain__Z6Y6s`,
	"card": `InvitePartnerPage_card__0JncS`,
	"inviteImg": `InvitePartnerPage_inviteImg__u6n9a`
};
export default ___CSS_LOADER_EXPORT___;
